import { render, staticRenderFns } from "./OneTimePassword.vue?vue&type=template&id=88157702&scoped=true"
import script from "./OneTimePassword.vue?vue&type=script&lang=js"
export * from "./OneTimePassword.vue?vue&type=script&lang=js"
import style0 from "./OneTimePassword.vue?vue&type=style&index=0&id=88157702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88157702",
  null
  
)

export default component.exports